export const hasDiacritics = text => {
  const pattern = /[\u0300-\u036f]/g;
  return pattern.test(text.normalize('NFD'));
};

export const removeDiacritics = text => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
